import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CommunitySpaces from '../Home/CommunitySpaces';

const OrganizationCollections = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.user);

  useEffect(() => {
    // Check if user has access to organization features
    if (!userData) {
      return;
    }

    if (userData.part_of_organization !== true || !userData.organization_id) {
      // User is not part of an organization, redirect to community
      navigate('/community-spaces');
      return;
    }
  }, [userData, navigate]);

  // If user doesn't have access, return null (will redirect)
  if (!userData || userData.part_of_organization !== true || !userData.organization_id) {
    return null;
  }

  // Use CommunitySpaces component with organization filtering - same UI as /community-spaces
  return (
    <CommunitySpaces 
      organizationMode={true}
      organizationId={userData.organization_id}
      pageTitle="Organization Collections"
    />
  );
};

export default OrganizationCollections;
